export default "__VITE_ASSET__B7Kj2Mvn__"